import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
    apiKey: "AIzaSyDgDqhdCKUN2GfewkTC_uzEXpwjw9zq4TI",
    authDomain: "mymoney-3bcac.firebaseapp.com",
    projectId: "mymoney-3bcac",
    storageBucket: "mymoney-3bcac.appspot.com",
    messagingSenderId: "167478075563",
    appId: "1:167478075563:web:e823265a3e0a02219fd7ee"
  };


// init firebase

firebase.initializeApp(firebaseConfig)

// init services

const projectFirestore = firebase.firestore()

const projectAuth = firebase.auth()

// timestamp

const timestamp = firebase.firestore.Timestamp

export {projectFirestore, projectAuth, timestamp}